import type { App } from '../app/App';
import type { GameSceneOptions } from '../game/scene/GameSceneOptions';
import type { LevelData } from '../game/level/LevelData';
import { startNewLevel } from './startNewLevel';

export function restartLevel(app: App, options: GameSceneOptions): void {
  const levelData: LevelData = options.saveProgress ? app.stateController.resetLevel() : options.levelData;
  startNewLevel(app, { ...options, levelData });
}
